module.exports = __webpack_public_path__ + "static/media/arrow-up-circle.c6f58c9c.svg";